import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Gql } from '@fiverr-private/dynamic_matching';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';
import { Budget } from './Budget';
import { DeliveryTimeline, Frequency, HiringDuration, TimeCommitment } from './Timeline';

export interface BudgetAndTimelineProps {
  pricingType: SellerBriefResponse['pricingType'];
  budgetInCents: SellerBriefResponse['budgetInCents'];
  deliveryDate: SellerBriefResponse['deliveryDate'];
  timeline: SellerBriefResponse['timeline'];
  needType: SellerBriefResponse['needType'];
  budgetRangeInCents: SellerBriefResponse['budgetRangeInCents'];
  timelineDetails: SellerBriefResponse['timelineDetails'];
  originalBuyerBudget: SellerBriefResponse['originalBuyerBudget'];
  originalBuyerBudgetRange: SellerBriefResponse['originalBuyerBudgetRange'];
  scope: 'seller' | 'buyer';
}

export const BudgetAndTimeline: React.FC<BudgetAndTimelineProps> = ({
  pricingType,
  budgetInCents,
  deliveryDate,
  timeline,
  needType,
  budgetRangeInCents,
  timelineDetails,
  originalBuyerBudget,
  originalBuyerBudgetRange,
  scope,
}) => (
  <Stack rowGap="4" wrap="wrap" columnGap="12">
    <Budget
      budgetInCents={budgetInCents}
      budgetRangeInCents={budgetRangeInCents}
      needType={needType}
      pricingType={pricingType}
      originalBuyerBudget={originalBuyerBudget}
      originalBuyerBudgetRange={originalBuyerBudgetRange}
      scope={scope}
    />
    {needType === Gql.DmBriefNeedType.Ongoing && timelineDetails?.hiringDuration && (
      <HiringDuration duration={timelineDetails.hiringDuration} />
    )}
    {needType === Gql.DmBriefNeedType.Ongoing &&
      pricingType === Gql.BriefPricingType.Hourly &&
      timelineDetails?.timeCommitment && <TimeCommitment commitment={timelineDetails?.timeCommitment} />}
    {needType !== Gql.DmBriefNeedType.Ongoing && (
      <DeliveryTimeline
        deliveryTimeline={timeline}
        specificDate={deliveryDate}
        generalTimeline={timelineDetails?.generalTimeline}
      />
    )}
    {needType === Gql.DmBriefNeedType.Ongoing &&
      pricingType === Gql.BriefPricingType.Fixed &&
      timelineDetails?.deliveriesFrequency && <Frequency frequency={timelineDetails.deliveriesFrequency} />}
  </Stack>
);
